import * as yup from "yup";

import { validator as companyDataValidator } from "./CompanyData/validator";
import { validator as contactPersonDataValidator } from "./ContactPersonData/validator";
import { validator as ownerDataValidator } from "./OwnerData/validator";
import { validator as personDataValidator } from "./PersonData/validator";
import { validator as vehicleDataValidator } from "./VehicleData/validator";

export const validator = yup.object({
  ...vehicleDataValidator,
  ...ownerDataValidator,
  ...companyDataValidator,
  ...personDataValidator,
  ...contactPersonDataValidator,
});
